function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MainTemplate = require('./main.template');
var RustscriptEditor = require('./editor');
var RustscriptPanel = require('./panel');
var WelcomeOverlay = require('./overlays/welcome');
var PublicKeyFieldOverlay = require('./overlays/fields/publickey');
var SignatureFieldOverlay = require('./overlays/fields/signature');
var TextFieldOverlay = require('./overlays/fields/text');
var HashFieldOverlay = require('./overlays/fields/hash');
var LogicalFieldOverlay = require('./overlays/fields/logical');
var NumberFieldOverlay = require('./overlays/fields/number');
var OpcodesOverlay = require('./overlays/opcodes');
var PublishFlow = require('./overlays/publish');
var PublishNFTFlow = require('./overlays/publish-nft');
var UnlockFlow = require('./overlays/unlock');
var UnlockFeeFlow = require('./overlays/unlock-fee');
var SpendOutputFlow = require('./overlays/spend-output');
var ImportFlow = require('./overlays/import');
var ScriptImportFlow = require('./overlays/import-script');
var ContinueUnlockImportFlow = require('./overlays/import-continue-unlock');
var SaveLaterFlow = require('./overlays/save-later');
var PostPublishFlow = require('./overlays/post-publish');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var _require = require('./overlays/overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
var _require2 = require('./script_validate'),
  evaluateWorkspaceStatus = _require2.evaluateWorkspaceStatus,
  deriveWorkflowIndicator = _require2.deriveWorkflowIndicator,
  isWitnessPhaseComplete = _require2.isWitnessPhaseComplete,
  resolveFieldOverlayKind = _require2.resolveFieldOverlayKind;
var _require3 = require('./script_build'),
  build_test_script_from_create = _require3.build_test_script_from_create,
  lockingView = _require3.lockingView,
  expandLockingTree = _require3.expandLockingTree;
var PanelMenu = require('./panel_menu');
var _require4 = require('./unlock_tx_fee'),
  hasUnlockFee = _require4.hasUnlockFee;
var _require5 = require('./unlock_tx_edit'),
  remainingSaitoNolan = _require5.remainingSaitoNolan,
  remainingNftUnits = _require5.remainingNftUnits,
  unlockUserOutputs = _require5.unlockUserOutputs;
var MOUNT_SELECTOR = '.saito-container';
var WORKSPACE_SELECTOR = 'main.rustscript';
var RustscriptMain = /*#__PURE__*/function () {
  function RustscriptMain(app, mod) {
    _classCallCheck(this, RustscriptMain);
    this.app = app;
    this.mod = mod;
    this.container = MOUNT_SELECTOR;
    this.workspaceMode = 'locked';
    this.testingUnlocked = false;
    this.selectedUnlockInputIndex = null;
    this.executionStatus = {
      attempted: false,
      success: false
    };
    this.validationDisplay = null;
    this.lastScriptSource = '';
    this.createEditor = new RustscriptEditor(app, mod, '#rustscript-editor-create', 'create');
    this.testEditor = new RustscriptEditor(app, mod, '#rustscript-editor-test', 'test');
    this.panel = new RustscriptPanel(app, mod, '#rustscript-panel', this);
    this.welcomeOverlay = new WelcomeOverlay(app, mod, this);
    this.opcodesOverlay = new OpcodesOverlay(app, mod);
    this.publishFlow = new PublishFlow(app, mod, this);
    this.publishNftFlow = new PublishNFTFlow(app, mod, this, this.publishFlow);
    this.unlockFlow = new UnlockFlow(app, mod, this);
    this.unlockFeeFlow = new UnlockFeeFlow(app, mod, this);
    this.spendOutputFlow = new SpendOutputFlow(app, mod, this);
    this.importFlow = new ImportFlow(app, mod, this);
    this.scriptImportFlow = new ScriptImportFlow(app, mod, this);
    this.continueUnlockImportFlow = new ContinueUnlockImportFlow(app, mod, this);
    this.saveLaterFlow = new SaveLaterFlow(app, mod, this);
    this.postPublishFlow = new PostPublishFlow(app, mod, this);
    this.generateExpertOverlay = new SaitoOverlay(app, mod, false);
    this.fieldOverlays = {
      publickey: new PublicKeyFieldOverlay(app, mod),
      signature: new SignatureFieldOverlay(app, mod),
      text: new TextFieldOverlay(app, mod),
      message: new TextFieldOverlay(app, mod),
      hash: new HashFieldOverlay(app, mod),
      logical: new LogicalFieldOverlay(app, mod),
      number: new NumberFieldOverlay(app, mod)
    };
  }
  return _createClass(RustscriptMain, [{
    key: "render",
    value: function render() {
      var container = document.querySelector(MOUNT_SELECTOR);
      if (!container) {
        console.error("RustScript: mount container not found: ".concat(MOUNT_SELECTOR));
        return;
      }
      document.body.classList.add('rustscript');
      var workspaceQuery = "".concat(MOUNT_SELECTOR, " ").concat(WORKSPACE_SELECTOR);
      if (container.querySelector(WORKSPACE_SELECTOR)) {
        this.app.browser.replaceElementBySelector(MainTemplate(), workspaceQuery);
      } else {
        this.app.browser.addElementToSelector(MainTemplate(), MOUNT_SELECTOR);
      }
      this.syncEditorModes();
      this.attachEvents();
      this.refresh();
      this.welcomeOverlay.render('splash');
    }
  }, {
    key: "syncEditorModes",
    value: function syncEditorModes() {
      var mode = this.workspaceMode === 'locked' ? 'guided' : 'expert';
      this.createEditor.displayMode = mode;
      this.testEditor.displayMode = mode;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this,
        _document$querySelect,
        _document$querySelect2;
      var openWelcome = function openWelcome() {
        _this.welcomeOverlay.render('splash');
      };
      (_document$querySelect = document.querySelector('.rs-new-script')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', openWelcome);
      document.querySelectorAll('.rs-mode-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.dataset.mode;
          if (mode === 'expert') {
            _this.setWorkspaceMode('unlocked');
          } else if (mode === 'guided') {
            _this.setWorkspaceMode('locked');
          }
        });
      });
      (_document$querySelect2 = document.querySelector('.rs-publish-script')) === null || _document$querySelect2 === void 0 || _document$querySelect2.addEventListener('click', function () {
        if (!_this.shouldShowPublishButton()) {
          return;
        }
        if (_this.isUnlockCommandBarAction()) {
          _this.unlockFlow.openSolution();
        } else {
          _this.publishFlow.openChoice();
        }
      });
    }

    /** Loaded/imported on-chain script — unlock workflow, not a new publish. */
  }, {
    key: "isUnlockCommandBarAction",
    value: function isUnlockCommandBarAction() {
      return this.mod.workflow === 'unlock';
    }
  }, {
    key: "clearUnlockInputSelection",
    value: function clearUnlockInputSelection() {
      var _this$panel, _this$panel$render;
      this.selectedUnlockInputIndex = null;
      (_this$panel = this.panel) === null || _this$panel === void 0 || (_this$panel$render = _this$panel.render) === null || _this$panel$render === void 0 || _this$panel$render.call(_this$panel);
    }
  }, {
    key: "isScriptPublishable",
    value: function isScriptPublishable() {
      var status = evaluateWorkspaceStatus(lockingView(this.mod.getScript()), this.testingUnlocked ? this.mod.getScript() : {}, this.executionStatus, this.mod.opcodes);
      return status.script.state === 'ready';
    }

    /**
     * Command-bar Publish — "Open Publish Overlay".
     * Stays visible once the locking script is publishable until invalidation or reset.
     */
  }, {
    key: "shouldShowPublishButton",
    value: function shouldShowPublishButton() {
      var _this$executionStatus;
      var locking = lockingView(this.mod.getScript());
      var unlocking = this.testingUnlocked ? this.mod.getScript() : {};
      var status = evaluateWorkspaceStatus(locking, unlocking, this.executionStatus, this.mod.opcodes);
      if (status.script.state !== 'ready') {
        return false;
      }
      if (status.script.validation && status.script.validation.valid === false) {
        return false;
      }
      if (this.validationDisplay === 'invalid_json') {
        return false;
      }
      if (isWitnessPhaseComplete(unlocking, this.mod.opcodes) && (_this$executionStatus = this.executionStatus) !== null && _this$executionStatus !== void 0 && _this$executionStatus.attempted && this.executionStatus.success !== true) {
        return false;
      }
      if (this.isUnlockCommandBarAction()) {
        var _this$executionStatus2;
        if (!this.areUnlockOutputsComplete()) {
          return false;
        }
        if (!hasUnlockFee(this.mod)) {
          return false;
        }
        if (!isWitnessPhaseComplete(unlocking, this.mod.opcodes)) {
          return false;
        }
        if (((_this$executionStatus2 = this.executionStatus) === null || _this$executionStatus2 === void 0 ? void 0 : _this$executionStatus2.success) !== true) {
          return false;
        }
      }
      return true;
    }

    /**
     * Unlock broadcast requires user outputs that fully allocate locked assets.
     * Wallet change outputs do not count toward this check.
     */
  }, {
    key: "areUnlockOutputsComplete",
    value: function areUnlockOutputsComplete() {
      var _this$mod;
      if (!((_this$mod = this.mod) !== null && _this$mod !== void 0 && _this$mod.unlock_transaction_base)) {
        return false;
      }
      if (unlockUserOutputs(this.mod).length === 0) {
        return false;
      }
      var ctx = this.mod.unlockContext;
      if ((ctx === null || ctx === void 0 ? void 0 : ctx.assetType) === 'nft') {
        return remainingNftUnits(this.mod) === BigInt(0);
      }
      // Treat sub-display dust as complete — SAITO↔nolan round-trips can leave 1 nolan.
      return remainingSaitoNolan(this.mod) <= BigInt(1);
    }
  }, {
    key: "updatePublishButton",
    value: function updatePublishButton() {
      var slot = document.querySelector('.rs-publish-slot');
      var btn = document.querySelector('.rs-publish-script');
      if (!slot || !btn) {
        return;
      }
      var visible = this.shouldShowPublishButton();
      var isUnlock = this.isUnlockCommandBarAction();
      slot.classList.toggle('is-visible', visible);
      slot.setAttribute('aria-hidden', visible ? 'false' : 'true');
      btn.hidden = !visible;
      btn.textContent = isUnlock ? 'Broadcast Unlock Transaction' : 'Publish';
      btn.tabIndex = visible ? 0 : -1;
    }
  }, {
    key: "exportPanelScript",
    value: function exportPanelScript(scope) {
      try {
        var scriptPayload;
        if (scope === 'script-create') {
          scriptPayload = lockingView(this.mod.getScript());
        } else if (scope === 'script-test') {
          scriptPayload = this.mod.getScript();
        } else {
          scriptPayload = this.mod.getScript();
        }
        this.mod.exportScriptDraft(scriptPayload);
      } catch (_err) {
        /* export failed — no transient notification */
      }
    }
  }, {
    key: "bindPanelMenu",
    value: function bindPanelMenu(root, menuId) {
      var _this2 = this;
      PanelMenu.attach(root, {
        menuId: menuId,
        onAction: function onAction(action) {
          if (action === 'export') {
            _this2.exportPanelScript(menuId);
          }
        }
      });
    }
  }, {
    key: "setWorkspaceMode",
    value: function setWorkspaceMode(mode) {
      this.workspaceMode = mode === 'unlocked' ? 'unlocked' : 'locked';
      if (this.workspaceMode === 'unlocked') {
        this.testingUnlocked = true;
        this.syncTestScriptFromLocking();
      }
      this.syncEditorModes();
      this.applyWorkspaceUI();
      this.refresh();
    }
  }, {
    key: "enterCreateGuided",
    value: function enterCreateGuided(lockingScript) {
      this.testingUnlocked = false;
      this.executionStatus = {
        attempted: false,
        success: false
      };
      this.validationDisplay = null;
      this.workspaceMode = 'locked';
      var expanded = expandLockingTree(lockingView(lockingScript || {}), this.mod.opcodes);
      this.mod.setScript(expanded);
      this.syncEditorModes();
      this.applyWorkspaceUI();
      this.refresh();
    }
  }, {
    key: "enterCreateFromScratch",
    value: function enterCreateFromScratch() {
      var _this3 = this;
      this.resetWorkspaceToFresh({
        expertMode: false,
        workflow: 'create'
      }).then(function () {
        _this3.renderGenerateExpertOverlay();
      });
    }
  }, {
    key: "enterExpertMode",
    value: function enterExpertMode() {
      this.resetWorkspaceToFresh({
        expertMode: true,
        workflow: 'create'
      });
    }
  }, {
    key: "resetOverlayFlows",
    value: function resetOverlayFlows() {
      var _this$generateExpertO, _this$generateExpertO2, _this$publishFlow, _this$publishFlow$hid, _this$publishNftFlow, _this$publishNftFlow$, _this$unlockFlow, _this$unlockFlow$hide, _this$unlockFeeFlow, _this$unlockFeeFlow$h, _this$spendOutputFlow, _this$spendOutputFlow2, _this$importFlow, _this$importFlow$hide, _this$scriptImportFlo, _this$scriptImportFlo2, _this$continueUnlockI, _this$continueUnlockI2, _this$saveLaterFlow, _this$saveLaterFlow$h, _this$postPublishFlow, _this$postPublishFlow2;
      (_this$generateExpertO = this.generateExpertOverlay) === null || _this$generateExpertO === void 0 || (_this$generateExpertO2 = _this$generateExpertO.hide) === null || _this$generateExpertO2 === void 0 || _this$generateExpertO2.call(_this$generateExpertO);
      (_this$publishFlow = this.publishFlow) === null || _this$publishFlow === void 0 || (_this$publishFlow$hid = _this$publishFlow.hide) === null || _this$publishFlow$hid === void 0 || _this$publishFlow$hid.call(_this$publishFlow);
      (_this$publishNftFlow = this.publishNftFlow) === null || _this$publishNftFlow === void 0 || (_this$publishNftFlow$ = _this$publishNftFlow.hide) === null || _this$publishNftFlow$ === void 0 || _this$publishNftFlow$.call(_this$publishNftFlow);
      (_this$unlockFlow = this.unlockFlow) === null || _this$unlockFlow === void 0 || (_this$unlockFlow$hide = _this$unlockFlow.hide) === null || _this$unlockFlow$hide === void 0 || _this$unlockFlow$hide.call(_this$unlockFlow);
      (_this$unlockFeeFlow = this.unlockFeeFlow) === null || _this$unlockFeeFlow === void 0 || (_this$unlockFeeFlow$h = _this$unlockFeeFlow.hide) === null || _this$unlockFeeFlow$h === void 0 || _this$unlockFeeFlow$h.call(_this$unlockFeeFlow);
      (_this$spendOutputFlow = this.spendOutputFlow) === null || _this$spendOutputFlow === void 0 || (_this$spendOutputFlow2 = _this$spendOutputFlow.hide) === null || _this$spendOutputFlow2 === void 0 || _this$spendOutputFlow2.call(_this$spendOutputFlow);
      (_this$importFlow = this.importFlow) === null || _this$importFlow === void 0 || (_this$importFlow$hide = _this$importFlow.hide) === null || _this$importFlow$hide === void 0 || _this$importFlow$hide.call(_this$importFlow);
      (_this$scriptImportFlo = this.scriptImportFlow) === null || _this$scriptImportFlo === void 0 || (_this$scriptImportFlo2 = _this$scriptImportFlo.hide) === null || _this$scriptImportFlo2 === void 0 || _this$scriptImportFlo2.call(_this$scriptImportFlo);
      (_this$continueUnlockI = this.continueUnlockImportFlow) === null || _this$continueUnlockI === void 0 || (_this$continueUnlockI2 = _this$continueUnlockI.hide) === null || _this$continueUnlockI2 === void 0 || _this$continueUnlockI2.call(_this$continueUnlockI);
      (_this$saveLaterFlow = this.saveLaterFlow) === null || _this$saveLaterFlow === void 0 || (_this$saveLaterFlow$h = _this$saveLaterFlow.hide) === null || _this$saveLaterFlow$h === void 0 || _this$saveLaterFlow$h.call(_this$saveLaterFlow);
      (_this$postPublishFlow = this.postPublishFlow) === null || _this$postPublishFlow === void 0 || (_this$postPublishFlow2 = _this$postPublishFlow.hide) === null || _this$postPublishFlow2 === void 0 || _this$postPublishFlow2.call(_this$postPublishFlow);
      if (this.publishFlow) {
        this.publishFlow.p2shAddress = '';
        this.publishFlow.p2shHash = '';
        this.publishFlow.lastPublishedTx = null;
      }
    }

    /**
     * After on-chain confirmation: leave the wizard, return to the main page,
     * then show the Post Publish hand-off overlay above it.
     */
  }, {
    key: "openPostPublish",
    value: function () {
      var _openPostPublish = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$welcomeOverlay, _this$postPublishFlow3;
        var _ref,
          _ref$tx,
          tx,
          _ref$p2shAddress,
          p2shAddress,
          _ref$p2shHash,
          p2shHash,
          _ref$blockId,
          blockId,
          _ref$txOrdinal,
          txOrdinal,
          _ref$blk,
          blk,
          snapshot,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$tx = _ref.tx, tx = _ref$tx === void 0 ? null : _ref$tx, _ref$p2shAddress = _ref.p2shAddress, p2shAddress = _ref$p2shAddress === void 0 ? '' : _ref$p2shAddress, _ref$p2shHash = _ref.p2shHash, p2shHash = _ref$p2shHash === void 0 ? '' : _ref$p2shHash, _ref$blockId = _ref.blockId, blockId = _ref$blockId === void 0 ? null : _ref$blockId, _ref$txOrdinal = _ref.txOrdinal, txOrdinal = _ref$txOrdinal === void 0 ? null : _ref$txOrdinal, _ref$blk = _ref.blk, blk = _ref$blk === void 0 ? null : _ref$blk;
              snapshot = {
                tx: tx,
                p2shAddress: p2shAddress || '',
                p2shHash: p2shHash || '',
                blockId: blockId,
                txOrdinal: txOrdinal,
                blk: blk
              };
              _context.n = 1;
              return this.resetWorkspaceToFresh({
                expertMode: false,
                workflow: 'create'
              });
            case 1:
              (_this$welcomeOverlay = this.welcomeOverlay) === null || _this$welcomeOverlay === void 0 || _this$welcomeOverlay.render('splash');
              (_this$postPublishFlow3 = this.postPublishFlow) === null || _this$postPublishFlow3 === void 0 || _this$postPublishFlow3.openOverlay(snapshot);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openPostPublish() {
        return _openPostPublish.apply(this, arguments);
      }
      return openPostPublish;
    }()
  }, {
    key: "resetEditorShells",
    value: function resetEditorShells() {
      var root = document.querySelector("".concat(MOUNT_SELECTOR, " ").concat(WORKSPACE_SELECTOR));
      if (!root) {
        return;
      }
      ['#rustscript-editor-create', '#rustscript-editor-test'].forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) {
          el.innerHTML = '';
          delete el.dataset.rustscriptEventsAttached;
        }
      });
    }
  }, {
    key: "resetWorkspaceToFresh",
    value: function () {
      var _resetWorkspaceToFresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _ref2,
          _ref2$expertMode,
          expertMode,
          _ref2$workflow,
          workflow,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$expertMode = _ref2.expertMode, expertMode = _ref2$expertMode === void 0 ? false : _ref2$expertMode, _ref2$workflow = _ref2.workflow, workflow = _ref2$workflow === void 0 ? 'create' : _ref2$workflow;
              this.resetOverlayFlows();
              this.mod.resetUnlockWorkflow();
              if (workflow) {
                this.mod.workflow = workflow;
              }
              this.mod.setScript({});
              this.testingUnlocked = !!expertMode;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              this.validationDisplay = null;
              this.lastScriptSource = '';
              this.selectedUnlockInputIndex = null;
              this.workspaceMode = expertMode ? 'unlocked' : 'locked';
              this.resetEditorShells();
              this.syncEditorModes();
              this.applyWorkspaceUI();
              _context2.n = 1;
              return this.refresh({
                skipTestSync: true
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function resetWorkspaceToFresh() {
        return _resetWorkspaceToFresh.apply(this, arguments);
      }
      return resetWorkspaceToFresh;
    }()
  }, {
    key: "enterUnlockGuided",
    value: function () {
      var _enterUnlockGuided = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(lockingScript) {
        var locking, merged;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.mod.workflow = 'unlock';
              this.testingUnlocked = true;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              this.validationDisplay = null;
              this.workspaceMode = 'locked';
              // Preserve published locking shape exactly — do not expand (scripthash).
              locking = lockingView(lockingScript || {});
              merged = build_test_script_from_create(locking, {}, this.mod.opcodes);
              this.mod.setScript(merged);
              this.syncEditorModes();
              this.applyWorkspaceUI();
              _context3.n = 1;
              return this.refresh();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function enterUnlockGuided(_x) {
        return _enterUnlockGuided.apply(this, arguments);
      }
      return enterUnlockGuided;
    }()
    /**
     * Continue Unlock — same Unlock workspace, script/witnesses already present.
     * Does not strip witnesses or rebuild an empty test scaffold.
     */
  }, {
    key: "enterUnlockContinuation",
    value: function () {
      var _enterUnlockContinuation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(fullScript) {
        var locking, merged;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.mod.workflow = 'unlock';
              this.testingUnlocked = true;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              this.validationDisplay = null;
              this.workspaceMode = 'locked';
              // Preserve published locking shape exactly — do not expand (scripthash).
              locking = lockingView(fullScript || {});
              merged = build_test_script_from_create(locking, fullScript || {}, this.mod.opcodes);
              this.mod.setScript(merged);
              this.syncEditorModes();
              this.applyWorkspaceUI();
              _context4.n = 1;
              return this.refresh();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function enterUnlockContinuation(_x2) {
        return _enterUnlockContinuation.apply(this, arguments);
      }
      return enterUnlockContinuation;
    }()
  }, {
    key: "enterUnlockExpert",
    value: function () {
      var _enterUnlockExpert = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              this.mod.workflow = 'unlock';
              this.testingUnlocked = true;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              this.validationDisplay = null;
              this.mod.setScript({});
              this.setWorkspaceMode('unlocked');
              this.syncEditorModes();
              _context5.n = 1;
              return this.refresh();
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function enterUnlockExpert() {
        return _enterUnlockExpert.apply(this, arguments);
      }
      return enterUnlockExpert;
    }()
  }, {
    key: "applyWorkspaceUI",
    value: function applyWorkspaceUI() {
      var root = document.querySelector("".concat(MOUNT_SELECTOR, " ").concat(WORKSPACE_SELECTOR));
      if (!root) {
        return;
      }
      var guided = this.workspaceMode === 'locked';
      var isUnlockWorkflow = this.mod.workflow === 'unlock';
      root.classList.toggle('rs-workspace-guided', guided);
      root.classList.toggle('rs-workspace-locked', guided);
      root.classList.toggle('rs-workspace-unlocked', !guided);
      root.classList.toggle('rs-workflow-unlock', isUnlockWorkflow);
      root.classList.toggle('rs-workflow-create', !isUnlockWorkflow);
      document.body.classList.toggle('rs-workspace-guided', guided);
      document.body.classList.toggle('rs-workspace-unlocked', !guided);
      var locking = lockingView(this.mod.getScript());
      var unlocking = this.testingUnlocked ? this.mod.getScript() : {};
      var status = evaluateWorkspaceStatus(locking, unlocking, this.executionStatus, this.mod.opcodes);
      var scriptReady = status.script.state === 'ready';
      var isExpert = !guided;
      // Guided create → create + info. Guided test → test + info. Expert → create + test.
      var testLive = isExpert ? true : this.testingUnlocked && scriptReady;
      var createLive = isExpert ? true : !testLive;
      var infoLive = guided;
      root.classList.toggle('rs-workspace-testing', guided && testLive);
      document.body.classList.toggle('rs-workspace-testing', guided && testLive);
      this.updateWorkspaceToggle();
      this.refreshStatusIndicators();
      var createEditor = root.querySelector('#rustscript-editor-create');
      var testEditor = root.querySelector('#rustscript-editor-test');
      var infoPanel = root.querySelector('#rustscript-panel');
      if (createEditor) {
        createEditor.hidden = !createLive;
      }
      if (testEditor) {
        testEditor.hidden = !testLive;
      }
      if (infoPanel) {
        infoPanel.hidden = !infoLive;
      }
    }
  }, {
    key: "updateWorkspaceToggle",
    value: function updateWorkspaceToggle() {
      var _document$querySelect3, _document$querySelect4;
      var guided = this.workspaceMode === 'locked';
      (_document$querySelect3 = document.querySelector('.rs-mode-guided')) === null || _document$querySelect3 === void 0 || _document$querySelect3.classList.toggle('is-active', guided);
      (_document$querySelect4 = document.querySelector('.rs-mode-expert')) === null || _document$querySelect4 === void 0 || _document$querySelect4.classList.toggle('is-active', !guided);
    }
  }, {
    key: "refreshStatusIndicators",
    value: function refreshStatusIndicators() {
      var locking = lockingView(this.mod.getScript());
      var unlocking = this.testingUnlocked ? this.mod.getScript() : {};
      var workflow = deriveWorkflowIndicator({
        lockingScript: locking,
        unlockingScript: unlocking,
        testingUnlocked: this.testingUnlocked,
        execution: this.executionStatus,
        opcodes: this.mod.opcodes,
        validationDisplay: this.validationDisplay
      });
      this.setStatusReactor('.rs-status-script', workflow.script, {
        idle: 'Script not yet complete',
        ready: 'Script complete'
      });
      this.setStatusReactor('.rs-status-required', workflow.witness, {
        idle: 'Witness step not entered',
        warn: 'Complete required witness fields',
        ready: 'Witness complete'
      });
      this.setStatusReactor('.rs-status-valid', workflow.valid, {
        idle: 'Script evaluation not started',
        warn: 'Witness supplied but script returned false',
        ready: 'Script validates successfully'
      });
      this.setProgressConnector('.rs-progress-connector-1', workflow.arrow1);
      this.setProgressConnector('.rs-progress-connector-2', workflow.arrow2);
      var validEl = document.querySelector('.rs-status-valid');
      if (validEl) {
        var label = validEl.querySelector('.rs-status-reactor-label');
        if (label) {
          if (this.validationDisplay === 'invalid_json') {
            label.textContent = 'Invalid JSON';
          } else if (workflow.phase === 'evaluation_failed') {
            label.textContent = 'Script Invalid';
          } else {
            label.textContent = 'Script Valid';
          }
        }
      }
      this.updatePublishButton();
    }
  }, {
    key: "setStatusReactor",
    value: function setStatusReactor(selector, state, titles) {
      var el = document.querySelector(selector);
      if (!el) {
        return;
      }
      el.dataset.state = state;
      if (titles !== null && titles !== void 0 && titles[state]) {
        el.title = titles[state];
      }
    }
  }, {
    key: "setProgressConnector",
    value: function setProgressConnector(selector, state) {
      var el = document.querySelector(selector);
      if (!el) {
        return;
      }
      el.dataset.state = state;
    }
  }, {
    key: "syncTestScriptFromLocking",
    value: function syncTestScriptFromLocking() {
      // Witness scaffold only — locking keys stay as stored (hash-stable).
      var merged = build_test_script_from_create(lockingView(this.mod.getScript()), this.mod.getScript(), this.mod.opcodes);
      this.mod.setScript(merged);
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _ref3,
          _ref3$skipTestSync,
          skipTestSync,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _ref3 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, _ref3$skipTestSync = _ref3.skipTestSync, skipTestSync = _ref3$skipTestSync === void 0 ? false : _ref3$skipTestSync;
              if (this.testingUnlocked && !skipTestSync) {
                this.syncTestScriptFromLocking();
              }
              this.createEditor.render();
              if (!this.testingUnlocked) {
                _context6.n = 2;
                break;
              }
              this.testEditor.render();
              _context6.n = 1;
              return this.autoValidateTestScript();
            case 1:
              _context6.n = 3;
              break;
            case 2:
              this.validationDisplay = null;
              this.executionStatus = {
                attempted: false,
                success: false
              };
            case 3:
              this.applyWorkspaceUI();
              this.panel.render();
              this.updatePublishButton();
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }, {
    key: "openFieldOverlay",
    value: function openFieldOverlay(path) {
      var _this$mod2,
        _this4 = this;
      if (!path) {
        return;
      }
      if (((_this$mod2 = this.mod) === null || _this$mod2 === void 0 ? void 0 : _this$mod2.workflow) === 'unlock') {
        var _require6 = require('./unlock_tx_fee'),
          assertUnlockMutablePath = _require6.assertUnlockMutablePath;
        try {
          assertUnlockMutablePath(this.mod, path);
        } catch (err) {
          window.alert((err === null || err === void 0 ? void 0 : err.message) || String(err));
          return;
        }
      }
      var current = this.mod.getField(path);
      var kind = resolveFieldOverlayKind(current, path);
      var overlay = this.fieldOverlays[kind] || this.fieldOverlays.text;
      overlay.path = path;
      overlay.currentValue = current;
      overlay.onApply = function (next) {
        try {
          _this4.mod.setField(path, next);
          _this4.refresh();
        } catch (err) {
          window.alert((err === null || err === void 0 ? void 0 : err.message) || String(err));
        }
      };
      if (kind === 'text' || kind === 'message') {
        overlay.title = kind === 'message' ? 'Message' : 'Text';
        overlay.multiline = kind !== 'message';
        overlay.placeholder = kind === 'message' ? 'Message to sign or verify' : '';
        overlay.submitLabel = 'Apply';
      }
      if (kind === 'number') {
        var key = String(path).split('.').pop().toLowerCase();
        overlay.title = key === 'm' ? 'Threshold (M)' : key === 'n' ? 'Total Keys (N)' : 'Number';
        overlay.placeholder = '0';
      }
      var result = overlay.render();
      if (result && typeof result.then === 'function') {
        result["catch"](function () {});
      }
    }
  }, {
    key: "openOpcodeReference",
    value: function openOpcodeReference(key) {
      this.opcodesOverlay.open(key);
    }
  }, {
    key: "renderGenerateExpertOverlay",
    value: function renderGenerateExpertOverlay() {
      var _document$querySelect5,
        _this5 = this;
      var html = buildRustscriptOverlay({
        className: 'rs-overlay-prompt rs-expert-generate',
        title: 'Generate Expert Script',
        bodyHtml: "\n        <textarea class=\"saito-textarea rs-expert-input\" spellcheck=\"false\" placeholder=\"CHECKSIG[publickey=&quot;alice&quot;]&#10;AND&#10;IMPORTFIELD[key=&quot;duration&quot;]\"></textarea>\n        <p class=\"rs-prompt-validation rs-expert-generate-error\" hidden role=\"alert\"></p>\n      ",
        actionsHtml: "<button type=\"button\" class=\"rs-btn rs-btn-primary rs-expert-generate-btn\">Generate</button>"
      });
      this.generateExpertOverlay.show(html);
      var input = document.querySelector('.rs-expert-input');
      if (input) {
        input.value = '';
        requestAnimationFrame(function () {
          input.focus({
            preventScroll: true
          });
        });
      }
      (_document$querySelect5 = document.querySelector('.rs-expert-generate-btn')) === null || _document$querySelect5 === void 0 || _document$querySelect5.addEventListener('click', function () {
        var _document$querySelect6;
        var text = (_document$querySelect6 = document.querySelector('.rs-expert-input')) === null || _document$querySelect6 === void 0 || (_document$querySelect6 = _document$querySelect6.value) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.trim();
        var errorEl = document.querySelector('.rs-expert-generate-error');
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (!text) {
          return;
        }
        try {
          var result = _this5.mod.parseExpertScript(text);
          _this5.executionStatus = {
            attempted: false,
            success: false
          };
          _this5.validationDisplay = null;
          // Create path: expanded locking only — do not arm Test / attach witness.
          _this5.testingUnlocked = false;
          _this5.mod.setScript(result.lockingScript);
          _this5.lastScriptSource = text;
          _this5.generateExpertOverlay.hide();
          _this5.refresh();
        } catch (err) {
          if (errorEl) {
            errorEl.textContent = err.message || 'Failed to parse expert script';
            errorEl.hidden = false;
          }
        }
      });
    }
  }, {
    key: "autoValidateTestScript",
    value: function () {
      var _autoValidateTestScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _testEl$querySelector, _this$app, _this$app2, _this$mod3;
        var testEl, scriptReady, isExpert, scriptText, scriptJson, evaluate, evaluateWithTransaction, result, _require7, assignOutputSlipIndices, success, _t, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              testEl = document.querySelector('#rustscript-editor-test');
              if (testEl) {
                _context7.n = 1;
                break;
              }
              this.validationDisplay = null;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              return _context7.a(2);
            case 1:
              if (!testEl.hidden) {
                _context7.n = 2;
                break;
              }
              this.validationDisplay = null;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              return _context7.a(2);
            case 2:
              scriptReady = evaluateWorkspaceStatus(lockingView(this.mod.getScript()), this.mod.getScript(), this.executionStatus, this.mod.opcodes).script.state === 'ready';
              if (scriptReady) {
                _context7.n = 3;
                break;
              }
              this.validationDisplay = null;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              return _context7.a(2);
            case 3:
              if (isWitnessPhaseComplete(this.mod.getScript(), this.mod.opcodes)) {
                _context7.n = 4;
                break;
              }
              this.validationDisplay = null;
              this.executionStatus = {
                attempted: false,
                success: false
              };
              return _context7.a(2);
            case 4:
              isExpert = testEl.classList.contains('is-expert');
              scriptText = isExpert ? (_testEl$querySelector = testEl.querySelector('.rustscript-editor-expert')) === null || _testEl$querySelector === void 0 ? void 0 : _testEl$querySelector.value : JSON.stringify(this.mod.getScript());
              _context7.p = 5;
              scriptJson = JSON.parse(scriptText);
              _context7.n = 7;
              break;
            case 6:
              _context7.p = 6;
              _t = _context7.v;
              this.validationDisplay = 'invalid_json';
              this.executionStatus = {
                attempted: true,
                success: false
              };
              return _context7.a(2);
            case 7:
              evaluate = (_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.core) === null || _this$app === void 0 || (_this$app = _this$app.scripting) === null || _this$app === void 0 ? void 0 : _this$app.evaluate;
              evaluateWithTransaction = (_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.core) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.scripting) === null || _this$app2 === void 0 ? void 0 : _this$app2.evaluateWithTransaction;
              if (!(typeof evaluate !== 'function' && typeof evaluateWithTransaction !== 'function')) {
                _context7.n = 8;
                break;
              }
              return _context7.a(2);
            case 8:
              if (!(((_this$mod3 = this.mod) === null || _this$mod3 === void 0 ? void 0 : _this$mod3.workflow) === 'unlock' && typeof evaluateWithTransaction === 'function' && this.mod.unlock_transaction_final)) {
                _context7.n = 13;
                break;
              }
              _require7 = require('./unlock_tx_fee'), assignOutputSlipIndices = _require7.assignOutputSlipIndices;
              _context7.p = 9;
              assignOutputSlipIndices(this.mod.unlock_transaction_final);
              _context7.n = 10;
              return evaluateWithTransaction(scriptJson, this.mod.unlock_transaction_final);
            case 10:
              result = _context7.v;
              _context7.n = 12;
              break;
            case 11:
              _context7.p = 11;
              _t2 = _context7.v;
              this.validationDisplay = 'invalid';
              this.executionStatus = {
                attempted: true,
                success: false
              };
              this.updatePublishButton();
              return _context7.a(2);
            case 12:
              _context7.n = 16;
              break;
            case 13:
              if (!(typeof evaluate === 'function')) {
                _context7.n = 15;
                break;
              }
              _context7.n = 14;
              return evaluate(scriptJson);
            case 14:
              result = _context7.v;
              _context7.n = 16;
              break;
            case 15:
              return _context7.a(2);
            case 16:
              success = result === 1;
              this.validationDisplay = success ? 'valid' : 'invalid';
              this.executionStatus = {
                attempted: true,
                success: success
              };
              // Keep command-bar CTA in sync with validation (outputs/fee gates still apply).
              this.updatePublishButton();
            case 17:
              return _context7.a(2);
          }
        }, _callee7, this, [[9, 11], [5, 6]]);
      }));
      function autoValidateTestScript() {
        return _autoValidateTestScript.apply(this, arguments);
      }
      return autoValidateTestScript;
    }()
  }]);
}();
module.exports = RustscriptMain;